<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <!--  Personal info row  -->
        <div class="row pt-5">
            <!--  Personal image  -->
            <div v-if="getEmployee.image" class="col-12 col-xl-4 d-flex justify-content-center">
                <img :src="appUrl + getEmployee.image.contentUrl" alt="profile_photo" class="profile-img">
            </div>
            <div v-else class="col-12 col-xl-6 d-flex justify-content-center" style="border-radius: 50%">
                <img src="../../../public/images/employee.png" alt="profile_photo" class="profile-img-default">
            </div>

            <!--  Personal info  -->
            <div class="col-12 col-xl-6 mt-4 mt-xl-0">
                <div style="font-size: 24px; font-weight: 400; color: #000000">
                    {{ getEmployeeName(getEmployee) }}
                </div>
                <div v-if="optionsMonth.length" class="mt-1" style="font-size: 16px; color: #5b5b5b">
                    {{ getEmployeeGender(getEmployee) }},
                    {{ getEmployeeBirthDate(getEmployee) }}
                </div>

                <div class="mt-4" style="font-size: 16px; font-weight: 600; color: #8300C5;">{{ $t('person.contacts') }}</div>

                <div class="mt-1" style="font-weight: 600; color: #272727">
                    <span style="font-size: 16px; font-weight: 500; color: #5b5b5b">
                        {{ $t('person.telephone') + ': ' }}
                    </span>
                    {{ formatPhoneNumber(getEmployee.telephone) }}
                </div>
                <div v-if="getEmployee.user" style="font-weight: 600; color: #272727">
                    <span style="font-size: 16px; font-weight: 500; color: #5b5b5b">{{ $t('user.email') + ': ' }}</span>
                    {{ getEmployeeEmail(getEmployee) }}
                </div>
                <div v-if="getEmployee.employeeInformation" style="font-weight: 600; color: #272727">
                    <span v-if="getEmployee.employeeInformation.telegram" style="font-size: 16px; font-weight: 500; color: #5b5b5b">{{ $t('person.telegram') + ': ' }}</span>
                    {{ getEmployeeTelegram(getEmployee) }}
                </div>

                <div class="mt-4" v-if="getEmployee.additionalInformation" style="font-size: 16px; font-weight: 600; color: #8300C5;">
                    {{ $t('additionalInformation') }}
                </div>
                <div class="mt-1" v-if="getEmployee.additionalInformation">{{ getEmployee.additionalInformation }}</div>
            </div>
        </div>

        <div class="row py-4">
            <div class="col-12">
                <HrRow />
                    <div class="row px-4">
                        <div class="col-12 col-sm-6 col-md mt-4 mt-md-0">
                            <div style="font-size: 16px; color: #8300C5; font-weight: 700">{{ $t('employee.position') }}</div>
                            <div v-if="getEmployee['@type'] === 'Person'" style="font-size: 24px; font-weight: 700; color: #000000">{{ getEmployee.employeePositions[0].name }}</div>
                        </div>
                        <div class="col-12 col-sm-6 col-md mt-4 mt-md-0">
                            <div style="font-size: 16px; color: #8300C5; font-weight: 700">{{ $t('employee.hiredDate') }}</div>
                            <div style="font-size: 24px; font-weight: 700; color: #000000" v-if="getEmployee.employeeInformation">
                                {{ dateFormat(getEmployee.employeeInformation.hiredDate) }}
                            </div>
                            <div v-else style="font-size: 24px; font-weight: 700; color: #000000">-</div>
                        </div>
<!--                        <div class="col-12 col-sm-6 col-md mt-4 mt-md-0">-->
<!--                            <div style="font-size: 16px; color: #8300C5; font-weight: 700">Ishdan ketgan sana</div>-->
<!--                            <div style="font-size: 24px; font-weight: 700; color: #000000">-</div>-->
<!--                        </div>-->
                        <div class="col-12 col-sm-6 col-md mt-4 mt-md-0">
                            <div style="font-size: 16px; color: #8300C5; font-weight: 700">{{ $t('employee.salary') }}</div>
                            <div style="font-size: 24px; font-weight: 700; color: #000000" v-if="getEmployee.employeeInformation">
                                {{ showCurrencyById(getEmployee.employeeInformation.currency.id, getEmployee.employeeInformation.salary) }}
                            </div>
                            <div v-else style="font-size: 24px; font-weight: 700; color: #000000">-</div>
                        </div>
                        <div class="col-12 col-sm-6 col-md mt-4 mt-md-0">
                            <div style="font-size: 16px; color: #8300C5; font-weight: 700">{{ $t('kpi.salary.income') }}</div>
                            <div style="font-size: 24px; font-weight: 700; color: #000000">
                                {{ showCurrencyById(getEmployee.employeeInformation.currency.id, getEmployee.employeeInformation.bonus ? parseInt(getEmployee.employeeInformation.salary) +  parseInt(getEmployee.employeeInformation.bonus) : parseInt(getEmployee.employeeInformation.salary)) }}
                            </div>
                        </div>

                        <div v-if="hasRoleCeo() || getUserPerson.id === getEmployee.id" class="col-12 col-sm-6 col-md mt-4 mt-md-0">
                            <div style="font-size: 16px; color: #8300C5; font-weight: 700">{{ $t('kpi.bonus.title') }}</div>
                            <div style="font-size: 22px; font-weight: 700; color: #000000">
                                <router-link :to="$i18nHelper.getUrl('employee-bonus/' + getEmployee.id)" class="text-gray-600 underline">{{ $t('kpi.bonus.product') }}</router-link>
                            </div>
                        </div>
                    </div>
                <HrRow />
            </div>
        </div>
    </Row>
</template>

<script>
import Row from "@/components/html/Row.vue";
import {mapActions, mapGetters} from "vuex";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import HrRow from "@/components/html/HrRow.vue";
import accessMixin from "@/mixin/accessMixin";

export default {
    name: "Profile",
    components: {HrRow, Row},
    mixins: [dateFormattingMixin, currencyFormatMixin, accessMixin],
    data() {
        return {
            appUrl: process.env.VUE_APP_API_URL,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'employee.title', url: 'employees'},
                {name: 'profile'},
            ],
            optionsMonth: [
                {text: this.$t('statistics.month.Jan')},
                {text: this.$t('statistics.month.Feb')},
                {text: this.$t('statistics.month.Mar')},
                {text: this.$t('statistics.month.Apr')},
                {text: this.$t('statistics.month.May')},
                {text: this.$t('statistics.month.Jun')},
                {text: this.$t('statistics.month.Jul')},
                {text: this.$t('statistics.month.Aug')},
                {text: this.$t('statistics.month.Sep')},
                {text: this.$t('statistics.month.Oct')},
                {text: this.$t('statistics.month.Nov')},
                {text: this.$t('statistics.month.Dec')},
            ],
        }
    },
    computed: {
        ...mapGetters(['getEmployee', 'getUserPerson'])
    },
    methods: {
        ...mapActions(['fetchEmployee', 'setBreadcrumbItems']),
        getEmployeeName(employee) {
            return employee.givenName + ' ' + employee.familyName + ' ' + employee.additionalName
        },
        getEmployeeGender(employee) {
            return employee.gender === 1 ? this.$t('person.gender.man') : this.$t('person.gender.woman')
        },
        getEmployeeAge(employee) {
            return new Date().getFullYear() - new Date(employee.birthday).getFullYear() + ' ' + this.$t('person.age')
        },
        getEmployeeBirthDate(employee) {
            if (employee['@type'] === 'Person') {
                let date = new Date(employee.birthday);

                return  this.$t('employee.wasBornDay') + ' ' +
                    date.getFullYear() + '-' + this.$t('person.year') + ' ' +
                    date.getDate() + '-' + this.optionsMonth[date.getMonth()].text;
            }
        },
        formatPhoneNumber(number) {
            if (number) {
                return number.replace(/\D+/g, '').replace(/(\d{3})(\d{2})(\d{3})(\d{4})/, '+$1 ($2) $3-$4');
            }
        },
        getEmployeeEmail(employee) {
            return employee.user ? employee.user.email : ''
        },
        getEmployeeTelegram(employee) {
            return employee.employeeInformation.telegram ? employee.employeeInformation.telegram : ''
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$root.showOverlay = true

        this
            .fetchEmployee(this.$route.params.id)
            .then(() => {
                this.$root.showOverlay = false
            })
    }
}
</script>

<style scoped>

.profile-img {
    max-height: 250px;
}

.profile-img-default {
    max-height: 250px;
}
</style>